export enum RetailerTabEnum {
  PRODUCT = "product",
  DISTRIBUTORS = "distributors",
  EVENTS = "events",
  POLICIES = "policies",
}
